import styled from 'styled-components';

export const Container = styled.div`
display: flex;
width: 100%;
padding:48px 200px ;
`
export const Wrapper= styled.div`
width: 100%;
display: flex;
flex-direction: column;
`